import bookHotelIndex from '@/views/scene/bookHotel/index.vue';
const MainRoutes = Array.from({ length: 21 }, (_, i) => ({
  path: `bookHotel/index${i + 1}`,
  name: `bookHotelIndex${i + 1}`,
  component: () => import(`@/views/scene/bookHotel/index${i + 1}.vue`)
}))

export default {
  path: '/scene',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
     // 订酒店首页
    {
      path: 'bookHotelIndex',
      name: 'bookHotelIndex',
      component: bookHotelIndex
    },
    ...MainRoutes,
  ]
}
